import React from 'react';
import { ExternalLink } from 'lucide-react';
const partners = [{
  name: 'Marrero Armor',
  description: 'Our Ballistic Shield and Body Armor Partners',
  url: 'https://marreroarmor.com/products',
  logo: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=1856&user=1516&w=350&h=175&file=uploaded%2Fimages%2FRedesign%2FImage%20Gallery%2FMARRERO_ARMOR_Logo.jpg&opt=w3'
}, {
  name: 'Keyport Guns & Sporting Goods',
  description: 'Keyport Guns & Sporting Goods',
  url: 'https://keyportguns.com/',
  logo: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=1856&user=1516&w=350&h=175&file=uploaded%2Fimages%2FRedesign%2FImage%20Gallery%2FKeyport%20Logo%20Jpeg.jpg300x300.jpg&opt=w3'
}, {
  name: 'MotoShot',
  description: 'Use of Force-Threat Management Specialty Products',
  url: 'https://www.motoshot.com/articles/',
  logo: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=1856&user=1516&w=350&h=175&file=uploaded%2Fimages%2FRedesign%2FImage%20Gallery%2Fcropped-MotoShot-Logo-BK-768x158.png&opt=w3'
}, {
  name: 'Spartan Training Gear',
  description: 'Use of Force Practical Training Gear Partners',
  url: 'https://spartantraininggear.com',
  logo: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=1856&user=1516&w=350&h=175&file=uploaded%2Fimages%2FRedesign%2FImage%20Gallery%2Fhonorfewshield.png&opt=w3'
}, {
  name: 'The Falcon Consulting Group',
  description: 'Our Private Investigations and Professional Security Partners',
  url: 'https://falconconsultinggroup.com',
  logo: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=1856&user=1516&w=350&h=175&file=uploaded%2Fimages%2FRedesign%2FImage%20Gallery%2FThe%20Falcon%20Consulting%20Group.logo.jpg&opt=w3'
}, {
  name: 'ICI Companies',
  description: 'Our International Private Investigation, Professional Consulting and Training Partners',
  url: 'https://icicompanies.com/services/',
  logo: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=1856&user=1516&w=350&h=175&file=uploaded%2Fimages%2FRedesign%2FImage%20Gallery%2FICI%20Logo.png&opt=w3'
}, {
  name: 'Millennium Sensor',
  description: 'Millennium Sensor East Coast Reps',
  url: 'http://www.msensor.com/representatives.html',
  logo: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=1856&user=1516&w=350&h=175&file=uploaded%2Fimages%2FRedesign%2FImage%20Gallery%2FP3%20Logo%20for%20Modifying%20jpeg.jpg&opt=w3'
}, {
  name: 'J. Zamrok Consulting',
  description: 'Professional Consulting and Training Partner',
  url: 'http://www.jzamrok.com/services/apc/',
  logo: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=1856&user=1516&w=350&h=175&file=uploaded%2Fimages%2FRedesign%2FImage%20Gallery%2FLogo.jpg&opt=w3'
}, {
  name: 'TacMount Solutions',
  description: 'Our Specialty Ballistic Shield Tactical Lights Partners',
  url: 'https://www.tacmountsolutions.com',
  logo: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=1856&user=1516&w=350&h=175&file=uploaded%2Fimages%2FRedesigne%202024%2FFull%20Logo%20transparent%20WHITE.png&opt=w3'
}, {
  name: 'Milspec / Cobra Cuffs',
  description: 'Medina Tactical Dynamics is the Official Training Company for Cobra Cuffs',
  url: 'https://www.milspecplastics.com/cobra-cuffs/',
  logo: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=1856&user=1516&w=350&h=175&file=uploaded%2Fimages%2FRedesign%2FImage%20Gallery%2FMilspec_Cobra_Logo.jpg&opt=w3'
}, {
  name: 'Zarc International',
  description: 'Zarc International: Our OC-Pepper Spray Resource',
  url: 'https://www.zarc.com',
  logo: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=1856&user=1516&w=350&h=175&file=uploaded%2Fimages%2FRedesigne%202024%2FZ(R)Logo.jpg&opt=w3'
}];
export function PartnerGridSection() {
  return <section className="py-16 md:py-24 bg-brand-gray-900 border-y border-brand-gray-800" data-id="element-867">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-868">
        <div className="text-center mb-12 md:mb-16 max-w-4xl mx-auto" data-id="element-869">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-white uppercase tracking-wider mb-4" data-id="element-870">
            Our Partners
          </h2>
          <div className="w-16 h-0.5 bg-brand-teal mx-auto" data-id="element-871" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-12" data-id="element-872">
          {partners.map(partner => <a key={partner.name} href={partner.url} target="_blank" rel="noreferrer" className="group border border-brand-gray-800 bg-brand-black p-6 hover:border-brand-teal transition-colors flex flex-col" data-id="element-873">
              <div className="bg-white p-4 flex items-center justify-center h-[120px] mb-6" data-id="element-874">
                <img src={partner.logo} alt={partner.name} className="block max-w-full max-h-full object-contain" data-id="element-875" />
              </div>
              <h3 className="text-lg font-bold text-brand-white uppercase tracking-wide mb-2 group-hover:text-brand-teal transition-colors" data-id="element-876">
                {partner.name}
              </h3>
              <p className="text-sm text-brand-gray-400 flex-grow leading-relaxed" data-id="element-877">
                {partner.description}
              </p>
              <div className="mt-4 inline-flex items-center text-brand-gray-500 text-xs font-bold uppercase tracking-wider group-hover:text-brand-teal transition-colors" data-id="element-878">
                Visit Website <ExternalLink className="ml-1.5 w-3 h-3" data-id="element-879" />
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}